/**
 * Shared configuration constants used across multiple files
 * Page-specific constants should be declared at the top of their pages
 */

// =============================================================================
// API CONFIGURATION
// =============================================================================

export const API = {
  TIMEOUT_MS: 15 * 60 * 1000,        // 15 minutes for long-running operations
  DEFAULT_TIMEOUT_MS: 30000,          // 30 seconds for normal requests
}

// =============================================================================
// UI FEEDBACK
// =============================================================================

export const UI = {
  TOAST_DURATION_MS: 3000,
  TOAST_LONG_DURATION_MS: 5000,
  SEARCH_DEBOUNCE_MS: 300,
}
